import React from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';
import NoSSR from 'react-no-ssr';

import './FilterTitle.scss';

const COMMA = ',';
const SPACE = ' ';

const getFilterText = filter => trans(`search.filter_header.results.${filter}`);

const generateSuffixArray = citySlug => [
  trans('search.filter_header.results.in'),
  trans(`city.${citySlug}`)
];

const generateTitleElems = (types = [], citySlug, currentNeighborhood) => {
  const filterCopy = [...types];
  const lastFilter = filterCopy.pop();
  let shortTitle = lastFilter
    ? getFilterText(lastFilter)
    : trans('search.filter_header.results');
  const neighborhoodStr = [trans(`area.id_${currentNeighborhood}`) + COMMA];

  if (filterCopy.length) {
    const connector = trans('search.filter_header.results.and');
    const baseTitle = filterCopy
      .map(filter => trans(`search.filter_header.results.${filter}`))
      .join(`${COMMA}${SPACE}`);

    shortTitle = [baseTitle, connector, getFilterText(lastFilter)].join(SPACE);
  }

  return {
    shortStr: shortTitle,
    midStr: [shortTitle, ...generateSuffixArray(citySlug)].join(SPACE),
    longStr: [
      shortTitle,
      generateSuffixArray(citySlug)[0],
      neighborhoodStr,
      generateSuffixArray(citySlug)[1]
    ].join(SPACE)
  };
};

const getNeighborhoodTitle = neighborhoods =>
  neighborhoods.length === 1 ? neighborhoods[0] : '';

const FilterTitle = ({ types, citySlug, currentNeighborhood }) => {
  const neighborhood = getNeighborhoodTitle(currentNeighborhood);
  const title = generateTitleElems(types, citySlug, currentNeighborhood);

  return (
    <div className="filter-title">
      <NoSSR>
        <span className="filter-title__short">{title.shortStr}</span>
      </NoSSR>
      {!neighborhood ? (
        <span className="filter-title__long">{title.midStr}</span>
      ) : (
        <span className="filter-title__long">{title.longStr}</span>
      )}
    </div>
  );
};

FilterTitle.propTypes = {
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  citySlug: PropTypes.string.isRequired,
  currentNeighborhood: PropTypes.string
};

FilterTitle.defaultProps = {
  currentNeighborhood: ''
};

export default FilterTitle;
